// 3rd Party
import { Radio } from 'opencare-crown';
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { P, StyledFormItem } from 'common/styles/oc-styled-components';

import {
  useWindowDimensions,
  DIMENSIONS,
} from 'providers/WindowDimensionsProvider';

import { PrimaryMemberSwitch } from '../../../checkout-styled-components';

// Other

// Component
export const PrimaryMemberSwitchFormRow = ({
  isPrimaryMember,
  setPrimaryMember,
}) => {
  const { layout } = useWindowDimensions();

  return (
    <StyledFormItem
      marginbottom={`${layout === DIMENSIONS.MOBILE ? '10px' : '22px'}`}
      name="isPrimaryMember"
      initialValue={isPrimaryMember}
    >
      <P
        color="#6f6a71"
        margin={`${layout === DIMENSIONS.MOBILE ? '-.5em 0 0 0' : '0 0 10px'}`}
      >
        Are you the primary member / subscriber on your dental insurance plan?
      </P>
      <Radio.Group
        buttonStyle="solid"
        onChange={() => setPrimaryMember(!isPrimaryMember)}
        style={{ marginTop: 5, display: 'flex' }}
        value={isPrimaryMember}
      >
        <PrimaryMemberSwitch
          value
          primaryMemberToggle={isPrimaryMember}
          border="10px 0 0 10px"
        >
          <P fontSize="16px" fontWeight="600" margin="0">
            Yes {layout !== DIMENSIONS.MOBILE && 'I am the primary member'}
          </P>
        </PrimaryMemberSwitch>
        <PrimaryMemberSwitch
          primaryMemberToggle={!isPrimaryMember}
          value={false}
          border="0 10px 10px 0"
        >
          <P fontSize="16px" fontWeight="600" margin="0">
            No {layout !== DIMENSIONS.MOBILE && 'I am a dependent'}
          </P>
        </PrimaryMemberSwitch>
      </Radio.Group>
    </StyledFormItem>
  );
};

PrimaryMemberSwitchFormRow.propTypes = {
  isPrimaryMember: PropTypes.bool,
  setPrimaryMember: PropTypes.func,
};
